// DATA MUST BE ORDERED HERE BY DESCENDING KW (or calculator results may not be correct)

module.exports = [
  {
    KW: 2.5,
    productName: 'Onan P2500i',
    modelName: 'P2500i',
    basePrice: 815,
    isQuiet: false,
    specFile: 'spec-sheets/onan-P2500i.pdf',
    imageName: 'onan2500',
    isPortable: true,
    portableSpecList: [
      'Runs on Gasoline',
      'Fuel Efficient',
      'Quiet and Durable',
      'LED Display with Power Output, Remaining Run Time, Fuel Level, and More',
    ],
  },
  {
    KW: 4.5,
    productName: 'Onan P4500i',
    modelName: 'P4500i',
    basePrice: 1269,
    isQuiet: false,
    specFile: 'spec-sheets/onan-P4500i.pdf',
    imageName: 'onan4500',
    isPortable: true,
    portableSpecList: [
      'Runs on Gasoline',
      'Fuel Efficient',
      'Quiet and Durable',
      'Push Button and Remote Start',
      'LED Display with Power Output, Remaining Run Time, Fuel Level, and More',
    ],
  },
  {
    KW: 9.5,
    productName: 'Onan P9500df',
    modelName: 'P9500df',
    basePrice: 1049,
    isQuiet: false,
    specFile: 'spec-sheets/onan-P9500df.pdf',
    imageName: 'onan9500',
    isPortable: true,
    portableSpecList: [
      'Dual Fuel – Runs on Gasoline or LP Gas',
      'Transfer Switch Ready',
      'Fuel Efficient',
      'Push Button and Remote Start',
      '3-Year Warranty',
    ],
  },
  {
    KW: 13,
    productName: 'QuietConnect 13kW',
    modelName: 'RS13A',
    basePrice: 0,
    isQuiet: true,
    specFile: 'spec-sheets/RS13A-EN.pdf',
    imageName: 'qc',
  },
  {
    KW: 17,
    productName: 'QuietConnect 17kW',
    modelName: 'RS17A',
    basePrice: 0,
    isQuiet: true,
    specFile: 'spec-sheets/RS17A-EN.pdf',
    imageName: 'qc',
  },
  {
    KW: 20,
    productName: 'QuietConnect 20kW',
    modelName: 'RS20A',
    basePrice: 0,
    isQuiet: true,
    specFile: 'spec-sheets/RS20A-EN.pdf',
    imageName: 'qc',
  },
  {
    KW: 25,
    productName: 'QuietConnect 25kW',
    modelName: 'RS25',
    basePrice: 0,
    isQuiet: true,
    specFile: 'spec-sheets/RS25-EN.pdf',
    imageName: 'pc',
  },
  {
    KW: 30,
    productName: 'QuietConnect 30kW',
    modelName: 'RS30',
    basePrice: 0,
    isQuiet: true,
    specFile: 'spec-sheets/RS30-EN.pdf',
    imageName: 'pc',
  },
  {
    KW: 36,
    productName: 'QuietConnect 36kW',
    modelName: 'RS36',
    basePrice: 0,
    isQuiet: true,
    specFile: 'spec-sheets/RS36-EN.pdf',
    imageName: 'pc',
  },
  {
    KW: 40,
    productName: 'QuietConnect 40kW',
    modelName: 'RS40',
    basePrice: 0,
    isQuiet: true,
    specFile: 'spec-sheets/RS40-EN.pdf',
    imageName: 'pc',
  },
  {
    KW: 45,
    productName: 'QuietConnect 50kW',
    modelName: 'RS50',
    basePrice: 0,
    isQuiet: true,
    specFile: 'spec-sheets/RS50-EN.pdf',
    imageName: 'pc',
  },
  {
    KW: 50,
    productName: 'QuietConnect 50kW',
    modelName: 'RS50',
    basePrice: 0,
    isQuiet: true,
    specFile: 'spec-sheets/RS50-EN.pdf',
    imageName: 'pc',
  },
  {
    KW: 60,
    productName: 'QuietConnect 60kW',
    modelName: 'RS60',
    basePrice: 0,
    isQuiet: true,
    specFile: 'spec-sheets/RS60-EN.pdf',
    imageName: 'pc',
  },
  {
    KW: 80,
    productName: 'QuietConnect 80kW',
    modelName: 'RS80',
    basePrice: 0,
    isQuiet: true,
    specFile: 'spec-sheets/RS80-EN.pdf',
    imageName: 'pc',
  },
  {
    KW: 100,
    productName: 'QuietConnect 100kW',
    modelName: 'RS100',
    basePrice: 0,
    isQuiet: true,
    specFile: 'spec-sheets/RS100-EN.pdf',
    imageName: 'pc',
  },
  {
    KW: 125,
    productName: 'QuietConnect 125kW',
    modelName: 'RS125',
    basePrice: 0,
    isQuiet: true,
    specFile: 'spec-sheets/RS125-EN.pdf',
    imageName: 'rs',
  },
  {
    KW: 150,
    productName: 'QuietConnect 150kW',
    modelName: 'RS150',
    basePrice: 0,
    isQuiet: true,
    specFile: 'spec-sheets/RS150-EN.pdf',
    imageName: 'rs',
  },
];



// WEBPACK FOOTER //
// ./src/views/Home/components/configs/model-data-config.js